import { render, staticRenderFns } from "./InquiryUpdateServiceView.vue?vue&type=template&id=20a7c3f6"
import script from "./InquiryUpdateServiceView.vue?vue&type=script&lang=js"
export * from "./InquiryUpdateServiceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports